import { useMemo } from "react";

export interface GoogleDriveSourceSettingsText {
  starredFilesLabelText: string;
  starredFilesHintText: string;
  assignedCommentsLabelText: string;
  assignedCommentsHintText: string;
  sharedWithMeLabelText: string;
  sharedWithMeHintText: string;
  sharedDrivesLabelText: string;
  sharedDrivesHintText: string;
  nothingSelectedText: string;
}

export const useGoogleDriveSourceSettingsText = (
  t: (key: string) => string,
): GoogleDriveSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.googleDrive.${key}`);

    return {
      starredFilesLabelText: tKey("starredFilesLabel"),
      starredFilesHintText: tKey("starredFilesHint"),
      assignedCommentsLabelText: tKey("assignedCommentsLabel"),
      assignedCommentsHintText: tKey("assignedCommentsHint"),
      sharedWithMeLabelText: tKey("sharedWithMeLabel"),
      sharedWithMeHintText: tKey("sharedWithMeHint"),
      sharedDrivesLabelText: tKey("sharedDrivesLabel"),
      sharedDrivesHintText: tKey("sharedDrivesHint"),
      nothingSelectedText: tKey("nothingSelected"),
    };
  }, [t]);
};
